document.addEventListener("DOMContentLoaded", function () {
  const shippedTextElement = document.querySelector(".js-shipped-date");
  const orderHoursElement = document.querySelector(".js-order-hours");

  shippedTextElement.textContent = "";
  orderHoursElement.textContent = "";

  const currentDate = new Date();
  const hour = currentDate.getHours();
  const minute = currentDate.getMinutes();

  const isBefore2PM = hour < 14;

  let shippedDateText, orderHoursText;

  if (isBefore2PM) {
    shippedDateText = "today";
    const orderDeadline = new Date();
    orderDeadline.setHours(14, 0, 0, 0);
    const timeRemaining = orderDeadline - currentDate;
    const hoursLeft = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutesLeft = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
    );
    orderHoursText = `${hoursLeft}h ${minutesLeft}m`;
  } else {
    shippedDateText = "by tomorrow";
    const orderDeadline = new Date();
    orderDeadline.setDate(currentDate.getDate() + 1);
    orderDeadline.setHours(14, 0, 0, 0);
    const timeRemaining = orderDeadline - currentDate;
    const hoursLeft = Math.floor(timeRemaining / (1000 * 60 * 60));
    const minutesLeft = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
    );
    orderHoursText = `${hoursLeft}h ${minutesLeft}m`;
  }

  shippedTextElement.textContent += shippedDateText + "?";
  orderHoursElement.textContent += orderHoursText;

  const raw = '';
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  fetch('https://us-central1-functions-358315.cloudfunctions.net/location-request', requestOptions)
    .then((response) => response.json())
    .then((data) => {
      if (data.countryCode === 'US') {
        const afterpayAppMessageEl = document.querySelector('[id*="afterpay_on_site_messaging_payments_messaging"]');
        const orderByEl = document.getElementById('order-by');
        orderByEl.style.display = 'flex';


        if(afterpayAppMessageEl){
          orderByEl.style.marginTop = "20px";
        } else {
          orderByEl.style.marginTop = "0px";
        }
      }
    })
    .catch((error) => console.error('Error fetching location:', error))
});
